import paymentSchedulesServiceGen from "./generated/paymentSchedulesServiceGen";

class paymentSchedulesService extends paymentSchedulesServiceGen {
}

export default paymentSchedulesService;